// https://github.com/eslint/eslint/issues/15617
// this is a valid way to export default, should be fixed with above issue
// eslint-disable-next-line no-restricted-exports
export { default } from './video';
export { default as videoConfig } from './video.config';
